import React, { useState, useContext } from "react";
import VideoContext from "../../context/video/videoContext";
import "../../styles/fonts.css";
const Search = (props) => {
  const videoContext = useContext(VideoContext);
  const { getVideos } = videoContext;
  const [query, setQuery] = useState("");
  const onChange = (e) => {
    setQuery(e.target.value);
  };
  const onSearch = (e) => {
    e.preventDefault();
    getVideos({ q: query.toLowerCase().split(" ") });
    props.history.push(`/videos/${query.toLowerCase() || "*"}`);
    setQuery("");
  };
  return (
    <div className='d-block col-xl-4 col-lg-3 mx-auto col-md-7 col-12'>
      <form className='form-inline'>
        <div className='input-group mb-3 col-md-12'>
          <input
            name='q'
            className='form-control simplefont col-mg-12 '
            type='text'
            placeholder='Search'
            aria-label='Search'
            onChange={onChange}
          />{" "}
          <div className='input-group-append'>
            <button
              onClick={onSearch}
              className='btn btn-outline-success rounded-pill shadow-none slantfont'
            >
              <i className='fab fa-searchengin text-light'></i>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Search;
